import React, { Component } from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";

class Message extends Component {
  static propTypes = {
    beanName: PropTypes.string,
    questionKey: PropTypes.string
  };

  static defaultProps = {
    beanName: "",
    questionKey: ""
  };

  render() {
    const { questionKey } = this.props;

    return (
      <div className="Message">
        {questionKey ? <FormatMessage id={questionKey} /> : null}
      </div>
    );
  }
}

export default Message;